import React from "react";

const ASCII = `
██████╗ ███████╗███████╗██╗   ██╗███╗   ███╗███████╗
██╔══██╗██╔════╝██╔════╝██║   ██║████╗ ████║██╔════╝
██████╔╝█████╗  ███████╗██║   ██║██╔████╔██║█████╗  
██╔══██╗██╔══╝  ╚════██║██║   ██║██║╚██╔╝██║██╔══╝  
██║  ██║███████╗███████║╚██████╔╝██║ ╚═╝ ██║███████╗
╚═╝  ╚═╝╚══════╝╚══════╝ ╚═════╝ ╚═╝     ╚═╝╚══════╝`;

const Resume = () => (
  <div className="page resume">
    <div className="resume-header">
      <p className="ascii-logo">{ASCII}</p>
      <a className="resume-download" href="/resume.pdf" download="Ratiq-Narwal-Resume.pdf">
        ⬇ download
      </a>
    </div>
    <p className="page-path">~/portfolio/resume.pdf</p>

    <section className="resume-section">
      <h2 className="section-title">summary</h2>
      <p>
        Systems-minded engineer focused on Rust, developer tooling, and
        infrastructure.
      </p>
    </section>

    <section className="resume-section">
      <h2 className="section-title">skills</h2>
      <ul className="tag-list">
        <li className="tag">Rust</li>
        <li className="tag">Linux</li>
        <li className="tag">Docker</li>
        <li className="tag">Kubernetes</li>
        <li className="tag">CI/CD</li>
        <li className="tag">CLI development</li>
        <li className="tag">Build systems</li>
      </ul>
    </section>

    <section className="resume-section">
      <h2 className="section-title">experience</h2>
      <div className="resume-item">
        <h3>QA Automation Intern - Jostle</h3>
        <p className="resume-item-meta">2024 — 2025</p>
      </div>
    </section>

    <section className="resume-section">
      <h2 className="section-title">education</h2>
      <div className="resume-item">
        <h3>BASc - Computer Engineering — University of British Columbia</h3>
        <p className="resume-item-meta">2021 — 2026</p>
      </div>
    </section>
  </div>
);

export default Resume;
